import React, { useState } from "react";
import axios from "axios";
import "./BankPaymentLink.css";
import Navbar from "./Navbar";
import Footer from "./Footer";

const API_BASE_URL = "https://api.rescons.in";

const BankPaymentTransaction = () => {
  const [transactionId, setTransactionId] = useState("");
  const [receiptFile, setReceiptFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [uploadedReceiptUrl, setUploadedReceiptUrl] = useState("");

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (file && !file.type.startsWith("image/")) {
      alert("Only image files (JPG, PNG) are allowed.");
      return;
    }

    setReceiptFile(file);
  };

  const handleTransactionSubmit = async (e) => {
    e.preventDefault();

    if (!transactionId.trim() || !receiptFile) {
      alert("Please enter Transaction ID and upload the receipt image.");
      return;
    }

    // Get user information from sessionStorage
    const uid = sessionStorage.getItem('uid');
    const email = sessionStorage.getItem('email');
    const fullName = sessionStorage.getItem('fullName');
    const country = sessionStorage.getItem('country');

    if (!uid || !email) {
      alert("Please log in to submit your payment receipt.");
      return;
    }

    try {
      setUploading(true);

      const formData = new FormData();
      formData.append("receiptFile", receiptFile);
      formData.append("transactionId", transactionId);
      formData.append("uid", uid);
      formData.append("email", email);
      formData.append("fullName", fullName);
      formData.append("country", country);

      const backendRes = await axios.post(
        `${API_BASE_URL}/upload-receipt`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      if (backendRes.status === 200) {
        alert("Receipt uploaded successfully! Your payment will be verified shortly.");
        
        // Dispatch custom event to notify other components about payment update
        window.dispatchEvent(new CustomEvent('paymentUpdated', {
          detail: { uid: uid }
        }));
        
        setReceiptFile(null);
        setTransactionId("");
      }

      console.log("✅ Upload Success:", backendRes.data);
      setUploadedReceiptUrl(backendRes.data.url || "");
      setSubmitted(true);
      setTransactionId("");
      setReceiptFile(null);
    } catch (err) {
      console.error("❌ Upload Error:", err);
      alert(
        err?.response?.data?.message ||
          "Submission failed. Please try again later."
      );
    } finally {
      setUploading(false);
    }
  };

  return (
    <>
      <Navbar />
      <div className="bank-transaction-container">
        {!submitted ? (
          <>
            <h2>Bank Transfer Submission</h2>
            <form className="transaction-form" onSubmit={handleTransactionSubmit}>
              <label htmlFor="transactionId">Transaction/Reference ID:</label>
              <input
                type="text"
                id="transactionId"
                value={transactionId}
                onChange={(e) => setTransactionId(e.target.value)}
                placeholder="Enter your Transaction ID"
                required
              />

              <label htmlFor="receiptFile">Upload Bank Receipt (JPG/PNG only):</label>
              <input
                type="file"
                id="receiptFile"
                accept="image/*"
                onChange={handleFileChange}
                required
              />

              <button type="submit" className="submit-button" disabled={uploading}>
                {uploading ? "Uploading..." : "Submit"}
              </button>
            </form>
          </>
        ) : (
          <div className="confirmation-message">
            <h3>Thank you!</h3>
            <p>Your bank transfer receipt has been uploaded successfully.</p>
            {/* <p>Your payment has been recorded in our system and is pending verification.</p> */}
            <p>You will receive a confirmation message once your payment is verified by our team.</p>
            {uploadedReceiptUrl && (
              <div className="receipt-preview">
                <p>Receipt URL: <a href={uploadedReceiptUrl} target="_blank" rel="noopener noreferrer">View Receipt</a></p>
              </div>
            )}
            <button 
              className="submit-button" 
              onClick={() => setSubmitted(false)}
            >
              Submit Another Receipt
            </button>
          </div>
        )}
      </div>
      <br />
      <br />
      <Footer />
    </>
  );
};

export default BankPaymentTransaction;
